import { Calendar } from "primereact/calendar";
import React from "react";
import { FormSectionElements, FormSubSections } from "src/entities/formTemplateDataType";
import XMLParser from "../../utilities/XMLParser";
import classNames from 'classnames';
import FormValidationUtils from "../../utilities/FormValidationUtils";
import { LiveValidationErrMsg } from "../live-validation-errMsg/LiveValidationErrMsg";
import Utils from "../../utilities/Utils";
import { getAppId, getRootComponent, setPublicSecurePageVisibility } from "../../utilities/ElementUtils";
import { getTokens, signin } from "../../security/PublicSecure";


interface Props {
  field: FormSectionElements;
  editable: boolean;
  title;
  labelControlArray;
  requiredField;
  isEng: boolean;
  callback,
  returnIndex?: number,
  callbackStepIndex?: (index: number, returnIndex?: number) => void;
}

interface State {


}
export class PublicSecureButtonComponent extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);

  }

  arrayToString=(_a)=> {
    if (Array.isArray(_a)) {
      return _a.join(' '); 
    } else {
      return [_a]
    }
  }

  componentDidMount(): void {
      setPublicSecurePageVisibility(this.props.field, this.props.callback);
  }

  handleSecureButtonClick = async () => {
    await signin(getAppId(this.props.field), this.props.isEng);
    FormValidationUtils.runJavascript(this.props.field);

    if (this.props.field.StepperScript) {
      const customJSFunc = eval(`(${this.props.field.StepperScript})`);
      customJSFunc((index) => {
        let destination = index;
        if (this.props.returnIndex!=null) {
          destination = this.props.returnIndex;
          this.props.callbackStepIndex(destination);
        } else {
          if (typeof destination === "string") {
            const root = getRootComponent(this.props.field);
            const foundSection = root.ListOfFormSections.find(section => section.ENUTitle == destination);
            const indexNum = root.ListOfFormSections.indexOf(foundSection);
            this.props.callbackStepIndex(indexNum)
          } else {
            this.props.callbackStepIndex(destination);
          }
        }
      });
    }
    this.props.callback(this.props.field.parent.parent.parent);
  }

  render() {
    let field = this.props.field;
    let controlArray = [];
    let title = this.props.isEng ? this.props.field.ENUTitle : this.props.field.FRATitle;

    if (field.InitScript && Utils.isNotNullOrEmpty(field.InitScript)) {
      const customJSFunc = eval(`(${field.InitScript})`);
      try {
        customJSFunc(field, process.env);
      } catch (ex) {
        console.log(ex);
      }

      if (this.props.editable == false || field.Visible == false) {
        return null;
      }
    }
    
    const ClassName = "ontario-button " + this.arrayToString(this.props.field.ClassName);
    controlArray.push(
      <div style={{ textAlign: 'left' }} key={"button_" + field.parent.Id + "_" + field.Id}>
        <button className={ClassName} onClick={this.handleSecureButtonClick}>
          {title}
        </button>
      </div>);

    return controlArray;
  }
}